import { giphyBlack } from '@giphy/colors'
import { useEffect } from 'react'
import { fonts } from 'types'
import { DropdownButton, SelectList } from 'ui'
import { fontScale, fontTitle, fontUrl, fontFamily as getFontFamily, preloadFont } from 'utils'
import { useFontInfo } from '../../../hooks/use-font-info'

type Props = {
    buttonColor?: string
    className?: string
    fontFamily: string
    onChange?: (fontFamily: string) => void
}

const FONTS = fonts.map((font) => (
    <span key={fontTitle(font)} style={{ fontFamily: getFontFamily(font), fontSize: `${fontScale(font)}em` }}>
        {fontTitle(font)}
    </span>
))

const UGECaptionsEditorFont = ({ buttonColor = giphyBlack, className, fontFamily, onChange }: Props) => {
    const { fontScale, index, label } = useFontInfo(fontFamily)
    const labelStyle = { fontFamily, fontSize: `${fontScale}em` }

    function onIndexChange(index: number) {
        const font = fonts[index]

        onChange?.(getFontFamily(font))
    }

    useEffect(() => {
        fonts.forEach((font) => {
            try {
                preloadFont(fontUrl(font), getFontFamily(font))
            } catch (err) {}
        })
    }, [])

    return (
        <DropdownButton
            iconButtonOptions={{ color: buttonColor }}
            className={className}
            label={<span style={labelStyle}>{label}</span>}
        >
            <SelectList defaultIndex={index} options={FONTS} onChange={onIndexChange} />
        </DropdownButton>
    )
}

export default UGECaptionsEditorFont
